import { MouseEvent, ReactElement } from 'react';

import Input from '@/common/Input';
import { SortDirectionEnum, UserWithMarket } from '@/models/gen/graphql';
import Table from '@/common/Table';
import { UserSortColumnEnum } from './hook';
import useUsersTableState from './hook';

const toTableDirection = (direction: SortDirectionEnum | undefined): 'asc' | 'desc' | undefined => {
  if (direction === SortDirectionEnum.Asc) return 'asc';
  if (direction === SortDirectionEnum.Desc) return 'desc';
  return undefined;
};

type UsersTableHeaderProps = {
  data: UserWithMarket[];
  selected: string[];
  onSelect: (id: string | string[]) => void;
};

const UsersTableHeader = ({ data, selected, onSelect }: UsersTableHeaderProps): ReactElement => {
  const { sorting, onSort } = useUsersTableState(({ state }) => ({
    sorting: state.sorting,
    onSort: state.onSort,
  }));

  const allSelected = data.length > 0 && selected.length === data.length;
  const handleSelectAll = (): void => onSelect(allSelected ? [] : data.map((u) => u.id));

  const sortProps = (column: UserSortColumnEnum) => ({
    direction: sorting.column === column ? toTableDirection(sorting.direction) : undefined,
    onSort: (_event: MouseEvent<HTMLTableCellElement>): void => onSort(column),
  });

  return (
    <Table.Row header>
      <Table.Cell className="SELECT">
        <Input type="checkbox" checked={allSelected} onClick={handleSelectAll} />
      </Table.Cell>
      <Table.Cell className="USERNAME" sorting={sortProps(UserSortColumnEnum.username)}>
        USERNAME
      </Table.Cell>
      <Table.Cell className="NAME" sorting={sortProps(UserSortColumnEnum.firstName)}>
        NAME
      </Table.Cell>
      <Table.Cell className="EMAIL" sorting={sortProps(UserSortColumnEnum.email)}>
        EMAIL
      </Table.Cell>
      <Table.Cell className="ROLE">ROLE</Table.Cell>
      <Table.Cell className="LAST-LOGIN" sorting={sortProps(UserSortColumnEnum.lastLoginUtc)}>
        LAST LOGIN
      </Table.Cell>
      <Table.Cell className="AIRPORTS">AIRPORTS</Table.Cell>
      <Table.Cell className="EMPLOYEE-ID" sorting={sortProps(UserSortColumnEnum.employeeId)}>
        EMPLOYEE ID
      </Table.Cell>
      <Table.Cell className="ACTIVE" sorting={sortProps(UserSortColumnEnum.active)}>
        ACTIVE
      </Table.Cell>
      <Table.Cell className="RESET-PW">RESET PW</Table.Cell>
    </Table.Row>
  );
};

export default UsersTableHeader;
